const CargarCvSvg = () => {
  return (
		<svg
			width="18"
			height="15"
			viewBox="0 0 18 15"
			className="cargarCvSvg"
			fill="white"
		>
			<path d="M8.1 10.3125H9.9V4.6875H12.6L9 0L5.4 4.6875H8.1V10.3125Z" />
			<path d="M16.2 13.125H1.8V6.5625H0V13.125C0 14.1591 0.8073 15 1.8 15H16.2C17.1927 15 18 14.1591 18 13.125V6.5625H16.2V13.125Z" />
		</svg>
	);
}

export default CargarCvSvg
